import React, { useState } from 'react';
import { Code } from 'lucide-react';

interface SoarFieldMappingItemProps {
  fieldMapping: Record<string, string>;
}

const SoarFieldMappingItem: React.FC<SoarFieldMappingItemProps> = ({ fieldMapping }) => {
  const [expanded, setExpanded] = useState(false);

  const toggleExpanded = () => {
    setExpanded(!expanded);
  };

  // Count the number of mappings
  const mappingCount = Object.keys(fieldMapping).length;

  return (
    <div className="space-y-2">
      <div 
        className="flex items-center justify-between cursor-pointer text-sm p-2 bg-background-hover rounded hover:bg-background-hover/80"
        onClick={toggleExpanded}
      >
        <div className="flex items-center space-x-2">
          <Code size={16} className="text-blue-400" />
          <span>Field Mapping</span>
          <span className="text-blue-400 px-2 py-0.5 rounded-full text-xs border border-blue-400/30">
            {mappingCount} {mappingCount === 1 ? 'entry' : 'entries'}
          </span>
        </div>
        <button
          type="button"
          className="text-xs px-2 py-1 bg-background-hover hover:bg-background-hover/80 text-gray-300 rounded-md border border-gray-700/40"
        >
          {expanded ? 'Hide Details' : 'Show Details'}
        </button>
      </div>

      {expanded && (
        <div className="p-3 bg-background-hover rounded-md border border-gray-700/40">
          <pre className="text-xs text-gray-300 overflow-auto max-h-40">
            {JSON.stringify(fieldMapping, null, 2)}
          </pre>
        </div>
      )}
    </div>
  );
};

export default SoarFieldMappingItem; 